import classes from './Loading.module.css'

export default function Loading() {
    return (
        <div class={classes.wrapper}><div class={classes.loader}></div></div>
    );
};

